import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export type BillingServiceScope = 'managed' | 'all';

interface BillingServiceFilterProps {
  value: BillingServiceScope;
  onChange: (value: BillingServiceScope) => void;
}

/**
 * Which organizations the Morning Worklist lists: the ones JotPsych's billing
 * team works, or every organization with claim work.
 */
export function BillingServiceFilter({ value, onChange }: BillingServiceFilterProps) {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      // MUI passes null when the active segment is re-clicked; keep one on.
      onChange={(_, next: BillingServiceScope | null) => {
        if (next) onChange(next);
      }}
      aria-label="Organizations to show"
    >
      <ToggleButton value="managed" sx={{ whiteSpace: 'nowrap' }}>
        Managed billing
      </ToggleButton>
      <ToggleButton value="all" sx={{ whiteSpace: 'nowrap' }}>
        All organizations
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
